<!--
 * @Author: Merlin
 * @Date: 2024-05-29 16:47:38
 * @LastEditors: Merlin
 * @LastEditTime: 2024-06-27 11:26:49
 * @Description: 提示获胜比例和金额
-->

<template>
    <CasinoGameBarWinning
        class="mt-[30px]"
        :percentage="getWinPercentage()"
        :mutipler="caculateMutipler"
        :amount="amount"
    ></CasinoGameBarWinning>
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
import { useJoinStateStore } from '@/stores/cansino/joinState';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';

const t = useTranslation();

const props = defineProps({
    isUnder: {
        type: Boolean,
        required: false,
        default: false
    },
    progress: {
        type: Number,
        required: true,
    },
    amount: {
        type: Number,
        required: true,
    },
    mutipler: {
        type: Number,
        required: true,
    },
    history: {
        type: Object as PropType<BetHistoryType>,
    },
});

const fRTPValue = computed(()=>{
    // return 99.02;
    const sRTP = useJoinStateStore().config.rtp;
    const fRTP = Number.parseFloat(sRTP);
    return fRTP;
});

const emit = defineEmits(['update:mutipler']);

const getWinPercentage = () => {
    // return this.direction ? 99 - this.prediction : this.prediction
    // ↑ 原版公式 
    if (props.isUnder) {
        return props.progress;
    }
    return 99 - props.progress;
};

// ↓最终返回返现倍数，
// ↓例如滑动结果值是50，返现倍数 1.98xxx 
const caculateMutipler = computed(() => {
    if (props.history?.multi > 0){
        return (props.history.multi).toFixed(3);
    }
    // return Math.floor(this.houseEdge / (this.direction ? 99 - this.prediction : this.prediction) * 1e4) / 1e4 
    // ↑ 原版的计算公式 💥 ↓ 以下是说明 
    // this.houseEdge 疑似是 RTP 值，原版值是 99.02 
    // this.direction 表示方向，值为1表示押高区 
    // this.prediction 即是滑竿滑动后的数值 
    // 1e4 是常量 10_000
    const i10K = 10_000; 
    const fResult = Math.floor(fRTPValue.value / getWinPercentage() * i10K) / i10K;
    const fFinalValue = Number(getFixed(fResult, 2));
    return fFinalValue;
});

watch(
    ()=> props.progress,
    ()=>{
        emit('update:mutipler', caculateMutipler.value);
    },
    {
        immediate: true,
        deep: true
    },
);
</script>

